<div class="box_style_2">
  <h4 class="inner">Mein Konto</h4>
  <ul id="cat_nav">
    <li><a routerLinkActive="active" (click)="navToCustomerAccount()" style="cursor: pointer;">Benutzerangaben</a></li>
    <li><a routerLinkActive="active" (click)="navToCustomerOrders()" style="cursor: pointer;">Bestellungen</a></li>
  </ul>
</div>
